import * as yup from 'yup'

export const requestRemoveSchema = yup.object().shape({
	phone: yup.string().required({ key: 'required' }),
	email: yup.string().email('invalid_email').required('required'),
	comment: yup.string().required('required'),
})
